<template>
   <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 md4 offset-md4>
        <v-card>
          <v-toolbar class="primary" dark>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              label="Usuario"
              class="mt-5"
              v-model="login.username"
            ></v-text-field>
            <v-text-field
              label="contraseña"
              type="password"
              class="mt-5"
              v-model="login.password"
              v-bind:rules="error_login"
              @keyup.enter="loguear"
            ></v-text-field>
            <v-btn primary dark @click="loguear">Aceptar</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

  export default {
    created () {
      if (window.localStorage.getItem('token')) {
        this.$router.push({ path: 'home' })
      }
    },
    data () {
      return {
        login: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      loguear () {
        this.$store.dispatch('login', this.login)
      }
    },
    computed: {
      error_login: function () {
        if (this.$store.getters.error_authenticated) {
          return ['usuario o contraseña incorrectas']
        }
        return [!this.$store.getters.error_authenticate]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?53c43b62